var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluglassTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9842 11.6917C14.2523 10.8689 15.5087 2.6689 15.664 1.05312C15.7109 0.563762 15.5562 0.238578 15.2532 0.093418C14.8868 -0.0828027 14.3442 0.00530877 13.7148 0.23224C12.8514 0.543479 1.81419 5.22981 1.1765 5.50111C0.571767 5.75784 0 6.03802 0 6.4437C0 6.72895 0.169248 6.88933 0.635789 7.05604C1.12135 7.22909 2.34412 7.59991 3.06611 7.79895C3.76149 7.99102 4.55321 7.82431 4.99693 7.54857C5.46728 7.25635 10.8953 3.62417 11.2851 3.30596C11.6743 2.98775 11.9849 3.39534 11.6667 3.71418C11.3485 4.0324 7.6225 7.64872 7.13123 8.14949C6.53475 8.75739 6.95818 9.38748 7.35817 9.63976C7.8152 9.92755 11.1019 12.1322 11.597 12.4859C12.092 12.8396 12.5941 13 13.0536 13C13.5132 13 13.7554 12.3946 13.9842 11.6917Z",
    fill: "#5260F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluglassTelegram);
export default __webpack_public_path__ + "static/media/bluglass-telegram.2817c809812bbc395e8cede1c8c1da39.svg";
export { ForwardRef as ReactComponent };